export const getCategoryString = (category?: string, subcategory?: string) => {
    if (!category) {
        return null;
    }

    return category + (subcategory ? ` • ${subcategory}` : '');
};
